module.exports = __webpack_public_path__ + "img/84ec124.svg";